import React from 'react';
import LiveTileCard, { type Tile } from 'components/LiveTileCard';

interface WideLiveTileProps {
  tile: Tile;
  path: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const WideLiveTile = (props: WideLiveTileProps) => <LiveTileCard {...props} isolateTouch />;

export default WideLiveTile;
